import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: '[foundation-type-1]',
    templateUrl: './foundation-type-1.component.html',
    styleUrl: './foundation-type-1.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FoundationType1Component {
}
